import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Icon from '../../../../../../common/Icon';
import { LinkButton } from '../../../../../../styles/theme/default/buttons';
import {
  FormGroup,
  StyledCheckbox
} from '../../../../../../styles/theme/default/others';
import {
  BodyFour,
  SubtitleThree
} from '../../../../../../styles/theme/default/typography';
import { Tooltip } from '../../../Styles';

const Wrapper = styled.div`
  padding: 0 25px;
  margin-top: 40px;
  .inputs-wrapper {
    display: grid;
    grid-template-columns: 40% 20% 40%;
    grid-gap: 0px;
    align-items: center;
  }

  .wallpaper-title {
    margin-right: 8px;
  }

  .subtitle-how-to-btn {
    margin-bottom: 8px;
    display: flex;
    align-items: center;
  }

  .input-container {
    position: relative;
    margin-bottom: 0;

    label {
      font-family: ${({ theme }) => theme.fonts.primary};
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 23px;
      text-transform: lowercase;
      letter-spacing: 0;
      color: ${({ theme }) => theme.colors.charcoal};
    }
  }

  .ten-percent-checkbox {
    margin-top: 15px;
  }

  .static-value {
    position: absolute;
    font-weight: bold;
    font-size: 0.8em;
    color: #444;
    top: 17px;
    right: 10px;
  }

  .equal-sign {
    text-align: center;
  }

  .total-price {
    margin-top: 40px;
  }

  .ten-percent-txt {
    display: flex;
    align-items: center;
  }

  .tooltip-container {
    margin-left: 8px;
    position: relative;
  }

  .ten-percent {
    .tooltip-customize {
      right: -5px;
      left: unset;

      .tooltip-arrow {
        right: 5px;
        left: unset;
      }

      .desc {
        text-align: start;
      }
    }
    &:hover {
      .tooltip-customize {
        transform: scale(1);
      }
    }
  }

  @media (max-width: 992px) {
    .inputs-wrapper {
      grid-template-columns: 2fr 1fr 2fr;
    }
    .subtitle-how-to-btn {
      flex-direction: column;
      align-items: flex-start;
    }
  }
`;

// get rollSqFt from subcategoryId
export const getRollSqFt = subcategoryId => {
  if (subcategoryId == 28) {
    return 28;
  } else if (subcategoryId == 300) {
    return 72;
  } else {
    return 18;
  }
};

export default function WallpaperCalculator({
  setCartQuantity,
  productData,
  setShowHowToWallpaper
}) {
  const [rolls, setRolls] = useState(1);
  const [tenPercentExtra, setTenPercentExtra] = useState(false);
  const rollSquareFeet = getRollSqFt(
    productData?.frame?.primarySubcategory?.id
  );
  const [squareFeet, setSquareFeet] = useState(() => rollSquareFeet);

  useEffect(() => {
    const totalSquareFeetWithRolls = rolls * rollSquareFeet;
    const squareFeetWithExtraTenPercent = squareFeet * 1.1;
    if (tenPercentExtra) {
      if (squareFeetWithExtraTenPercent > totalSquareFeetWithRolls) {
        //set roles extra rolls
        const numberOfRolls = squareFeetWithExtraTenPercent / rollSquareFeet;
        const roundUpRolls = Math.ceil(numberOfRolls);
        setRolls(roundUpRolls);
        setCartQuantity(roundUpRolls);
      } else {
        handleRolls();
      }
    } else {
      // remove 10% extra
      handleRolls();
    }
  }, [tenPercentExtra, squareFeet]);

  const removeTenPercentOnChange = () => {
    if (tenPercentExtra) {
      setTenPercentExtra(false);
    }
  };

  const handleRolls = () => {
    const numberOfRolls = squareFeet / rollSquareFeet;
    let roundUpRolls = Math.ceil(numberOfRolls);
    if (roundUpRolls < 1) {
      roundUpRolls = 1;
    }
    setRolls(roundUpRolls);
    setCartQuantity(roundUpRolls);
  };

  const handleRollsChange = e => {
    removeTenPercentOnChange();
    const regex = /^[1-9][0-9]*(\.[0-9]+)?$/;
    const value = e.target.value;
    if (regex.test(value)) {
      setSquareFeet(e.target.value * rollSquareFeet);
      setRolls(e.target.value);
      setCartQuantity(parseInt(e.target.value));
    }
  };

  const handleSquareFeetChange = e => {
    removeTenPercentOnChange();
    const regex = /^[1-9][0-9]*(\.[0-9]+)?$/;
    const value = e.target.value;
    if (regex.test(value) || value === '') {
      setSquareFeet(e.target.value);
    }
  };

  const handleTenPercentExtra = () => {
    setTenPercentExtra(!tenPercentExtra);
  };

  return (
    <Wrapper>
      <div className="subtitle-how-to-btn">
        <SubtitleThree className="wallpaper-title" color="#6C6C6C" bold={true}>
          How much do you need?{' '}
        </SubtitleThree>
        <LinkButton
          onClick={() => setShowHowToWallpaper(true)}
          className="how-to-calculate-link"
          fontSize="14px"
        >
          How to Calculate
        </LinkButton>
      </div>

      <div className="inputs-wrapper">
        <FormGroup className="input-container">
          {/* <label htmlFor="squareFeet">Square Feet</label>{' '} */}
          <label htmlFor="squareFeet" className="static-value">
            sq ft.
          </label>
          <input
            type="text"
            name="squareFeet"
            id="squareFeet"
            placeholder=""
            value={squareFeet} // || add initial value
            onChange={handleSquareFeetChange}
          />
        </FormGroup>

        <div className="equal-sign">=</div>

        <FormGroup className="input-container">
          {/* <label htmlFor="rolls">Rolls</label>{' '} */}
          <label htmlFor="rolls" className="static-value">
            rolls
          </label>
          <input
            type="text"
            name="rolls"
            id="rolls"
            placeholder=""
            value={rolls} // || add initial value
            onChange={handleRollsChange}
          />
        </FormGroup>
      </div>

      <StyledCheckbox className="ten-percent-checkbox">
        <input
          type="checkbox"
          checked={tenPercentExtra}
          name="tenPercentExtra"
          onChange={handleTenPercentExtra}
        />
        <span className="checkmark" />
        <BodyFour className="ten-percent-txt">
          Add 10% extra for waste and reserve{' '}
          <div className="tooltip-container ten-percent">
            <Icon icon="ti-tooltip-info" size={25} color="#2A5CAF" />
            <Tooltip className="tooltip-customize">
              <div className="tooltip-arrow" />
              <BodyFour className="desc">
                We recommend an overage of 10% to account for any cuts, corners,
                waste, or any future replacement needs.
              </BodyFour>
            </Tooltip>
          </div>
        </BodyFour>
      </StyledCheckbox>

      <BodyFour className="total-price">
        <strong>Total Price: ${rolls * productData.price}</strong> ({rolls}{' '}
        rolls)
      </BodyFour>
    </Wrapper>
  );
}
